import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Assets from './Assets';
import { EmployeesPage } from './Employees';
import { Properties } from './properties/Properties';
import Residents from './residents/Residents';
import VendorsPage from './Vendors';
import VendorDetails from './Vendors/VendorDetails';
import { BlockDetails } from './properties/BlockDetails';
import { ApartmentUnitDetails } from './properties/ApartmentUnitDetails';
import { ParkingDetails } from './properties/ParkingDetails';
import AmenityDetails from './properties/AmenityDetails';
import ResidentDetails from './residents/ResidentDetails';
import EmployeeDetails from './Employees/EmployeeDetails';
import AssetDetails from './Assets/AssetDetails';

export const ResourcesRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/resources/assets" replace />} />
      <Route path="/assets" element={<Assets />} />
      <Route path="/assets/:id" element={<AssetDetails />} />
      <Route path="/employees" element={<EmployeesPage />} />
      <Route path="/employees/:id" element={<EmployeeDetails />} />
      <Route path="/vendors" element={<VendorsPage />} />
      <Route path="/vendors/:id" element={<VendorDetails />} />
      
      {/* Property Routes */}
      <Route path="/properties" element={<Properties />} />
      <Route path="/properties/blocks" element={<Properties />} />
      <Route path="/properties/blocks/:id" element={<BlockDetails />} />
      <Route path="/properties/units" element={<Properties />} />
      <Route path="/properties/units/:id" element={<ApartmentUnitDetails />} />
      <Route path="/properties/parkings" element={<Properties />} />
      <Route path="/properties/parkings/:id" element={<ParkingDetails />} />
      <Route path="/properties/amenities" element={<Properties />} />
      <Route path="/properties/amenities/:id" element={<AmenityDetails />} />
      
      {/* Resident Routes */}
      <Route path="/residents" element={<Residents />} />
      <Route path="/residents/:id" element={<ResidentDetails />} />
      
      <Route path="*" element={<Navigate to="/resources/assets" replace />} />
    </Routes>
  );
}; 